import { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Home from "./pages/Home";
import Projects from "./pages/AllProjects/Projects";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PdfEditor from "./pages/PdfEditor/PdfEditor";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "../styles/MainContent.css";
import useWindowWidth from "../hooks/useWindowWidth";
import { LanguageProvider, useLanguage } from "../hooks/LanguageContext";

const getRouteName = (pathname, isEnglish) => {
  const routes = {
    "/": { en: "HOME", es: "INICIO" },
    "/projects": { en: "PROJECTS", es: "PROYECTOS" },
    "/about": { en: "ABOUT ME", es: "SOBRE MÍ" },
    "/contact": { en: "CONTACT", es: "CONTACTO" },
    "/pdf-editor": { en: "PDF EDITOR", es: "EDITOR PDF" },
  };

  return routes[pathname]
    ? routes[pathname][isEnglish ? "en" : "es"]
    : routes["/"][isEnglish ? "en" : "es"];
};

function AppShell({
  isMobile,
  isSidebarVisible,
  setIsSidebarVisible,
  toggleSidebar,
}) {
  const location = useLocation();
  const { isEnglish } = useLanguage();
  const currentRoute = getRouteName(location.pathname, isEnglish);
  const isPdfEditor = location.pathname === "/pdf-editor";

  useEffect(() => {
    if (isPdfEditor) {
      setIsSidebarVisible(false);
    } else if (!isMobile) {
      setIsSidebarVisible(true);
    }
  }, [isPdfEditor, isMobile, setIsSidebarVisible]);

  return (
    <div
      className={`mainContent-container ${
        isPdfEditor
          ? "fullscreen-tool"
          : isSidebarVisible
            ? "sidebar-visible"
            : "sidebar-hidden"
      }`}
    >
      {!isPdfEditor && (
        <Sidebar
          isSidebarVisible={isSidebarVisible}
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}
        />
      )}
      <div className="main-section">
        <div className={`app-router ${isPdfEditor ? "app-router-tool" : ""}`}>
          {!isPdfEditor && (
            <Navbar
              toggleSidebar={toggleSidebar}
              isMobile={isMobile}
              currentRoute={currentRoute}
            />
          )}
          <div className="app-router-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/pdf-editor" element={<PdfEditor />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
}

function MainContent() {
  const isMobile = useWindowWidth();
  const [isSidebarVisible, setIsSidebarVisible] = useState(() => !isMobile);

  useEffect(() => {
    setIsSidebarVisible(!isMobile);
  }, [isMobile]);

  const toggleSidebar = () => {
    setIsSidebarVisible((prev) => !prev);
  };

  return (
    <LanguageProvider>
      <Router>
        <AppShell
          isMobile={isMobile}
          isSidebarVisible={isSidebarVisible}
          setIsSidebarVisible={setIsSidebarVisible}
          toggleSidebar={toggleSidebar}
        />
      </Router>
    </LanguageProvider>
  );
}

export default MainContent;
